import axios from "axios";

const api = axios.create({
  baseURL: "/api",
});

// Interceptor — adiciona token automaticamente
api.interceptors.request.use(config => {
  const token = localStorage.getItem("oo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Interceptor — trata erros
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("oo_token");
      localStorage.removeItem("oo_user");
      window.location.href = "/";
    }
    // Assinatura suspensa
    if (err.response?.status === 402) {
      window.location.href = "/suspenso";
    }
    return Promise.reject(err);
  }
);

export default api;
